import { ToggleButtonGroup } from "@mui/material";
import {
  ClockClockwiseIcon,
  CoinVerticalIcon,
  StarIcon,
} from "@phosphor-icons/react";
import { useTranslations } from "use-intl";

import { SortButton } from "@/components/SortButton/SortButton";
import {
  TripsSortOptions,
  type TripsSortValue,
} from "@/features/trips/types/types";
import { SortOrder } from "@/types/enums";

type Props = {
  value: TripsSortValue;
  onChange: (newValue: TripsSortValue) => void;
};

export function TripsSort({ value, onChange }: Props) {
  const t = useTranslations();

  return (
    <ToggleButtonGroup
      orientation="vertical"
      fullWidth
      exclusive
      size="small"
      color="primary"
      aria-label={t("sortOptions")}
    >
      <SortButton
        value={{ field: TripsSortOptions.POSITION, order: SortOrder.ASC }}
        isSelected={
          value.field === TripsSortOptions.POSITION &&
          value.order === SortOrder.ASC
        }
        onChange={onChange}
      >
        <StarIcon size={20} color="var(--color-text-secondary)" />
        {t("trips.sortOrder.recommended")}
      </SortButton>

      <SortButton
        value={{ field: TripsSortOptions.PRICE, order: SortOrder.ASC }}
        isSelected={
          value.field === TripsSortOptions.PRICE &&
          value.order === SortOrder.ASC
        }
        onChange={onChange}
      >
        <CoinVerticalIcon size={20} color="var(--color-text-secondary)" />
        {t("trips.sortOrder.lowestPrice")}
      </SortButton>

      <SortButton
        value={{ field: TripsSortOptions.CREATED_AT, order: SortOrder.DESC }}
        isSelected={
          value.field === TripsSortOptions.CREATED_AT &&
          value.order === SortOrder.DESC
        }
        onChange={onChange}
      >
        <ClockClockwiseIcon size={20} color="var(--color-text-secondary)" />
        {t("trips.sortOrder.mostRecent")}
      </SortButton>
    </ToggleButtonGroup>
  );
}
